import { useContext, useState as classicUseState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import { State } from '@hookstate/core';

import { Icon as BlueIcon } from '@blueprintjs/core';

import { useMutation } from 'react-query';

import { toast } from 'react-toast';

import { changePassword } from '@services/queries/auth';

import AvatarPlaceholder from '@assets/svg/avatar-placeholder.svg';

import { trackUserLoggedOut } from '@services/mixpanel/trackers/UserSessionMetrics';
import { NavigationContext } from '@layout/navigation/navigation';
import {
  Container,
  Header,
  Buttons,
  Content,
  WindowButton,
  Icon,
  ProfileImg,
  Row,
  Column,
  Hf,
} from './ProfileContent.styles';
import { EditUserDetails } from './components/EditUserDetails/EditUserDetails';

interface IAddFieldContent {
  openAddField: State<boolean>;
  userName: string;
  userPicture: string;
  userId: string;
}

const ProfileContent = (props: IAddFieldContent) => {
  const { openAddField, userName, userPicture, userId } = props;
  const { logout, user } = useAuth0();
  const mutationChangePassword = useMutation(changePassword, {
    onSuccess: () => {
      toast.success('Check your email for further instructions');
    },
  });
  const [editUser, setEditUser] = classicUseState(false);
  const { studioName } = useContext(NavigationContext);
  return (
    <Container>
      <Header>
        Account
        <WindowButton
          onClick={() => {
            openAddField.set(false);
          }}
        >
          <BlueIcon icon="cross" color="#8F95B2" />
        </WindowButton>
      </Header>
      <Row>
        <Icon>
          {userPicture ? (
            <ProfileImg src={userPicture} alt="" />
          ) : (
            <ProfileImg src={AvatarPlaceholder} alt="" />
          )}
        </Icon>
        <Column>
          <Content>{userName}</Content>
          <Content className="email">{user?.email}</Content>
        </Column>
      </Row>

      <Buttons onClick={() => setEditUser(true)}>
        <BlueIcon icon="edit" color="#8F95B2" />
        Edit Profile
      </Buttons>

      <Buttons
        onClick={() => {
          mutationChangePassword.mutate({
            email: user?.email,
            client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
            connection: 'Username-Password-Authentication',
          });
        }}
      >
        <BlueIcon icon="shield" color="#8F95B2" />
        Reset Password
      </Buttons>

      <Hf />

      <Buttons
        onClick={() => {
          trackUserLoggedOut(studioName);
          logout();
        }}
      >
        <BlueIcon icon="log-out" color="#8F95B2" />
        Sign-out
      </Buttons>

      <EditUserDetails
        open={editUser}
        onClose={() => setEditUser(false)}
        userName={userName}
        userPicture={userPicture}
        userId={userId}
      />
    </Container>
  );
};
export { ProfileContent };
